import React, {Component, createElement} from 'react';
import {Route, RouteComponentProps, Switch} from 'react-router-dom';
import {Constants, GlobalStyles, parseQuery} from './Common';
import {CustomerPortalDashboard, CustomerPortalMyItems} from './Pages';

const {
  NewCustomerPortalUrl: {
    BETA_DASHBOARD_URL,
    BETA_ITEMS_URL,
    BETA_DONATION_ITEMS_URL,
    BETA_RECYCLE_ITEMS_URL,
    BETA_EXPIRED_ITEMS_URL,
    BETA_AUCTION_ITEMS_URL,
  },
} = Constants;

export class Router extends Component<Record<string, unknown>> {
  render(): JSX.Element {
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
    return (
      <div className='NewCustomerPortal'>
        <GlobalStyles />
        <Switch>
          <Route exact path={BETA_DASHBOARD_URL} render={render(CustomerPortalDashboard)} />
          <Route exact path={BETA_ITEMS_URL} render={render(CustomerPortalMyItems)} />
          <Route
            exact
            path={BETA_AUCTION_ITEMS_URL}
            render={render(CustomerPortalMyItems, {resaleType: 'auction'})}
          />
          <Route
            exact
            path={BETA_DONATION_ITEMS_URL}
            render={render(CustomerPortalMyItems, {resaleType: 'donation'})}
          />
          <Route
            exact
            path={BETA_RECYCLE_ITEMS_URL}
            render={render(CustomerPortalMyItems, {resaleType: 'recycle'})}
          />
          <Route
            exact
            path={BETA_EXPIRED_ITEMS_URL}
            render={render(CustomerPortalMyItems, {resaleType: 'expired'})}
          />
          <Route exact path='*' render={render(NotFoundPage)} />
        </Switch>
      </div>
    );
  }
}
function NotFoundPage(): JSX.Element {
  return (
    <div>
      <div className='text-center'>
        <h2>404 - Not found</h2>
        <br />
        <a href={BETA_DASHBOARD_URL}>Dashboard</a>
      </div>
    </div>
  );
}
type RenderType = (
  props: RouteComponentProps<{[K: string]: string | undefined}>,
) => React.ReactNode;
export function render(component: unknown, rest?: Record<string, unknown>): RenderType {
  const fn = ({
    location,
    match,
    ...props
  }: {
    location: {search: string};
    match: {params: unknown};
  }) => {
    // @ts-ignore
    return createElement(component, {
      ...props,
      match,
      params: match.params,
      location: {...location, query: parseQuery(location.search || '')},
      ...rest,
    });
  };
  return fn;
}
